export default {
  focusable: false,
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  roundedBottom: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  padding: '2',
  fontSize: '3',
  showOriginDestinationImage: false,
  separatorJourneyTypeProps: {
    content: '|',
    fontWeight: 'bold',
  },
  showJourneyType: true,
  fareItemJourneyType: {
    fontWeight: 'bold',
  },
  showTravelClass: true,
  fareItemTravelClass: {
    fontWeight: 'bold',
  },
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showSeparator: true,
    separatorKey: 'to',
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'capitalize',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
    separatorStyles: {
      paddingLeft: '1',
      textTransform: 'lowercase',
      fontWeight: 'light',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    departureText: 'cmp-label--departure-date-colon',
    showDepartureText: true,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    returnText: 'cmp-label--return-date-colon',
    showReturnText: true,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showDurationTrip: true,
  fareItemTripDuration: {
    fontWeight: 'bold',
  },
  fareBodyItem: {
    grow: '2',
    justifyContent: 'start',
    padding: '1',
  },
  fareFooterItem: {
    justifyContent: 'between',
    alignItems: 'end',
    grow: '1',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: false,
    fontWeight: 'bold',
    textAlign: 'right',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
      marginRight: '2',
    },
    currencyStyles: {
      fontSize: '6',
      style: {
        lineHeight: '1',
      },
    },
  },
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    paddingHeight: '1',
    paddingWidth: '5',
  },
  showCallToAction: true,
  showLastSeen: true,
  fareItemLastSeen: {
    paddingHeight: '1',
    labelStyles: {
      fontWeight: 'bold',
    },
  },
};
